// extracted by mini-css-extract-plugin
export default {"tableAvatar":"adminUserList_tableAvatar__-x0UT","imgActual":"adminUserList_imgActual__GAKFf","popUpAvatar":"adminUserList_popUpAvatar__LcFR5"};